import { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import './Navbar.css';

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/features', label: 'Features' },
  { to: '/flow', label: 'How it works' },
  { to: '/technology', label: 'Technology' },
  { to: '/impact', label: 'Impact' },
  { to: '/dashboard', label: 'Dashboard', href: 'https://backend.nirvixtech.com/dashboard' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="container nav__inner">
        <Link to="/" className="nav__brand" aria-label="SETU home">
          <Logo variant="full" />
        </Link>

        <nav className="nav__links" aria-label="Main">
          {navItems.map((item) =>
            item.href ? (
              <a
                key={item.to}
                href={item.href}
                className="nav__link"
              >
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) => `nav__link ${isActive ? 'is-active' : ''}`}
              >
                {item.label}
              </NavLink>
            )
          )}
        </nav>

        <div className="nav__cta">
          <Link to="/contact" className="btn btn--primary btn--sm">
            Request demo
            <span className="arrow" aria-hidden>→</span>
          </Link>
        </div>

        <button
          className={`nav__burger ${open ? 'is-open' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span /><span /><span />
        </button>
      </div>

      <div className={`nav__mobile ${open ? 'is-open' : ''}`}>
        <nav className="nav__mobile-links" aria-label="Mobile">
          {navItems.map((item) =>
            item.href ? (
              <a
                key={item.to}
                href={item.href}
                className="nav__mobile-link"
              >
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) => `nav__mobile-link ${isActive ? 'is-active' : ''}`}
              >
                {item.label}
              </NavLink>
            )
          )}
          <Link to="/contact" className="btn btn--primary" style={{ marginTop: 12 }}>
            Request demo →
          </Link>
        </nav>
      </div>
    </header>
  );
}
